import { GenIcon } from '../helpers/IconBase.es.js';
import 'tslib';
import 'react';
import '@teko/styled';
import '../helpers/IconContext.es.js';

const FlashSaleFilled = (props) => {
    return GenIcon({
        tag: 'svg',
        attr: { viewBox: '0 0 24 24', fill: 'none' },
        child: [
            {
                tag: 'path',
                attr: {
                    fillRule: 'evenodd',
                    clipRule: 'evenodd',
                    d: 'M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM9.27655 5.41169C9.37245 4.86779 9.89111 4.50462 10.435 4.60053L16.5319 5.67558C16.898 5.74012 17.0681 6.16732 16.8467 6.46585L13.3551 11.1733C13.2222 11.3524 13.3243 11.6087 13.544 11.6475L15.36 11.9677C15.74 12.0347 15.9041 12.4887 15.6548 12.7832L9.75245 19.7537C9.55456 19.9874 9.17488 19.8093 9.22806 19.5077L10.1988 14.0023C10.2468 13.7304 10.0652 13.4711 9.79323 13.4231L8.9069 13.2668C8.363 13.1709 7.99984 12.6523 8.09574 12.1084L9.27655 5.41169Z',
                    fill: '#82869E',
                },
            },
        ],
    })(props);
};

export { FlashSaleFilled };
